﻿import * as React from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import TooltipText from '../../../../../../shared/feedback/TooltipText';
import { formatDate } from '../../../../../../shared/LanguageService';

type VideoFileInformationLabels = {
    downloadButtonTooltip: string;
    uploadedLabel: string;
};

type VideoFileInformationProps = {
    filename: string;
    uploadedAt: string;
    fileReference: string;
    labels: VideoFileInformationLabels;
};

function VideoFileInformation({
    filename,
    uploadedAt,
    fileReference,
    labels
}: VideoFileInformationProps) {
    let { apiUrl } = window.appConfig;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', padding: '22px 16px', minWidth: 0 }}>
                <Typography variant="body1" sx={{ fontSize: '16px', wordBreak: 'break-word' }}>
                    {filename}
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.54)' }}>
                    {`${labels.uploadedLabel} ${formatDate(new Date(uploadedAt), 'yyyy-MM-dd')}`}
                </Typography>
            </Box>
            <Box sx={{ flex: '1 auto' }} />
            <Box sx={{ padding: '0 16px', flexShrink: 0 }}>
                <form method="GET" action={`${apiUrl}/file/${fileReference}`}>
                    <Tooltip
                        title={<TooltipText variant="body1">{labels.downloadButtonTooltip}</TooltipText>}
                    >
                        <IconButton type="submit" aria-label="download video">
                            <DownloadIcon sx={{ width: '24px', height: '24px' }} />
                        </IconButton>
                    </Tooltip>
                </form>
            </Box>
        </Box>
    );
}

export default VideoFileInformation;
